var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCoupons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8575 1.5H12.1432C14.46 1.5 15.75 2.835 15.75 5.1225V12.87C15.75 15.195 14.46 16.5 12.1432 16.5H5.8575C3.5775 16.5 2.25 15.195 2.25 12.87V5.1225C2.25 2.835 3.5775 1.5 5.8575 1.5ZM6.06011 4.995V4.9875H8.30185C8.6251 4.9875 8.8876 5.25 8.8876 5.57175C8.8876 5.9025 8.6251 6.165 8.30185 6.165H6.06011C5.73686 6.165 5.47511 5.9025 5.47511 5.58C5.47511 5.2575 5.73686 4.995 6.06011 4.995ZM6.06011 9.555H11.9401C12.2626 9.555 12.5251 9.2925 12.5251 8.97C12.5251 8.6475 12.2626 8.38425 11.9401 8.38425H6.06011C5.73686 8.38425 5.47511 8.6475 5.47511 8.97C5.47511 9.2925 5.73686 9.555 6.06011 9.555ZM6.06002 12.9825H11.94C12.2393 12.9525 12.465 12.6968 12.465 12.3975C12.465 12.09 12.2393 11.835 11.94 11.805H6.06002C5.83502 11.7825 5.61752 11.8875 5.49752 12.0825C5.37752 12.27 5.37752 12.5175 5.49752 12.7125C5.61752 12.9 5.83502 13.0125 6.06002 12.9825Z",
    fill: "#362269"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCoupons);
export default __webpack_public_path__ + "static/media/ActiveCoupons.c8029e1e9019b7d772bdf56ec9ee30f2.svg";
export { ForwardRef as ReactComponent };